module.exports = __webpack_public_path__ + "img/no1.66f575cd.svg";